import React from 'react';
import { connect } from 'react-redux';
import PianoTechUserTable from './components/PianoTechUser/PianoTechUserTable';
import PianoTechUser from './components/PianoTechUser/PianoTechUser';
import PianoTechCompanyTable from './components/PianoTechCompany/PianoTechCompanyTable';
import PianoTechCompany from './components/PianoTechCompany/PianoTechCompany';
import PianoTechnicianTable from './components/PianoTechnician/PianoTechnicianTable';
import PianoTechnician from './components/PianoTechnician/PianoTechnician';
import PianoTechCustomerTable from './components/PianoTechCustomer/PianoTechCustomerTable';
import PianoTechCustomer from './components/PianoTechCustomer/PianoTechCustomer';
import PianoTechPianoTable from './components/PianoTechPiano/PianoTechPianoTable';
import PianoTechPiano from './components/PianoTechPiano/PianoTechPiano';
import PianoTechAppointmentTable from './components/PianoTechAppointment/PianoTechAppointmentTable';
import PianoTechAppointment from './components/PianoTechAppointment/PianoTechAppointment';

import Login from './components/Login/Login';
import Header from '../src/components/layout/Header';
import Button from './components/layout/Button';

import {
    VIEW_PIANOTECHUSER_LIST,
    VIEW_PIANOTECHUSER_UPDATE,
    VIEW_PIANOTECHCOMPANY_LIST,
    VIEW_PIANOTECHCOMPANY_UPDATE,
    VIEW_PIANOTECHNICIAN_LIST,
    VIEW_PIANOTECHNICIAN_UPDATE,
    VIEW_PIANOTECHCUSTOMER_LIST,
    VIEW_PIANOTECHCUSTOMER_UPDATE,
    VIEW_PIANOTECHPIANO_LIST,
    VIEW_PIANOTECHPIANO_UPDATE,
    VIEW_PIANOTECHAPPOINTMENT_LIST,
    VIEW_PIANOTECHAPPOINTMENT_UPDATE,
    PIANOTECHUSER_TABLE,
    PIANOTECHCOMPANY_TABLE,
    PIANOTECHNICIAN_TABLE,
    PIANOTECHCUSTOMER_TABLE,
    PIANOTECHPIANO_TABLE,
    PIANOTECHAPPOINTMENT_TABLE,
    TABLE_NAME_SELECTED,
} from './app-constants';

const mapStateToProps = state => ({
    pianoTechUser: state.pianoTechUser,
    pianoTechCompany: state.pianoTechCompany,
    pianoTechnician: state.pianoTechnician,
    pianoTechCustomer: state.pianoTechCustomer,
    user: state.user,
    pianoTechPiano: state.pianoTechPiano,
    pianoTechAppointment: state.pianoTechAppointment,
});

class App extends React.PureComponent {

    changeApplications = (e) => {
        const tableName = e.target.id;

        console.log('App.jsx changeApplications tableName: ' + tableName);

        this.props.dispatch({
            type: TABLE_NAME_SELECTED,
            tableName,
        })

    }

    render() {

        const { pianoTechCompany } = this.props.pianoTechCompany;

        let hasCompanySetup = false;

        if (pianoTechCompany && pianoTechCompany.companyId) {
            hasCompanySetup = true;
        }

        return (
            <div>
                <table width="100%">
                    <tbody>
                        <tr>
                            <td width="15%" align="center">
                                <Header header2={'QRS MTech System'} />
                            </td>
                        </tr>
                        <tr>
                            <td width="100%" align="center">
                                {this.props.user.loginStatus === 'LOGGED_IN' &&
                                    <React.Fragment>
                                        {!hasCompanySetup &&
                                            <Button className="bluebutton-wide" id="PianoTechCompany" description="Company Setup" onClick={this.changeApplications} />
                                        }
                                        {hasCompanySetup &&
                                            <React.Fragment>
                                                <Button className="bluebutton2-wide" id="PianoTechCompany" description="Company Setup" onClick={this.changeApplications} />
                                                <Button className="bluebutton2-wide" id="PianoTechnician" description="Piano Technicians" onClick={this.changeApplications} />
                                                <Button className="bluebutton-wide" id="PianoTechCustomer" description="Customers" onClick={this.changeApplications} />
                                            </React.Fragment>
                                        }
                                    </React.Fragment>
                                }
                            </td>
                        </tr>
                    </tbody>
                </table>
                {
                    this.props.user.loginStatus === 'LOGGED_OUT' &&
                    <Login />
                }
                {
                    this.props.user.tableName === PIANOTECHUSER_TABLE && this.props.pianoTechUser.view === VIEW_PIANOTECHUSER_LIST &&
                    <PianoTechUserTable />
                }
                {
                    this.props.user.tableName === PIANOTECHUSER_TABLE && this.props.pianoTechUser.view === VIEW_PIANOTECHUSER_UPDATE &&
                    <PianoTechUser />
                }
                {this.props.user.tableName === PIANOTECHCOMPANY_TABLE && this.props.pianoTechCompany.view === VIEW_PIANOTECHCOMPANY_LIST &&
                    <PianoTechCompanyTable />
                }
                {this.props.user.tableName === PIANOTECHCOMPANY_TABLE && this.props.pianoTechCompany.view === VIEW_PIANOTECHCOMPANY_UPDATE &&
                    <PianoTechCompany />
                }
                {this.props.user.tableName === PIANOTECHNICIAN_TABLE && this.props.pianoTechnician.view === VIEW_PIANOTECHNICIAN_LIST &&
                    <PianoTechnicianTable />
                }
                {this.props.user.tableName === PIANOTECHNICIAN_TABLE && this.props.pianoTechnician.view === VIEW_PIANOTECHNICIAN_UPDATE &&
                    <PianoTechnician />
                }
                {this.props.user.tableName === PIANOTECHCUSTOMER_TABLE && this.props.pianoTechCustomer.view === VIEW_PIANOTECHCUSTOMER_LIST &&
                    <PianoTechCustomerTable />
                }
                {this.props.user.tableName === PIANOTECHCUSTOMER_TABLE && this.props.pianoTechCustomer.view === VIEW_PIANOTECHCUSTOMER_UPDATE &&
                    <PianoTechCustomer />
                }
                {this.props.user.tableName === PIANOTECHPIANO_TABLE && this.props.pianoTechPiano.view === VIEW_PIANOTECHPIANO_LIST &&
                    <PianoTechPianoTable />
                }
                {this.props.user.tableName === PIANOTECHPIANO_TABLE && this.props.pianoTechPiano.view === VIEW_PIANOTECHPIANO_UPDATE &&
                    <PianoTechPiano />
                }
                {this.props.user.tableName === PIANOTECHAPPOINTMENT_TABLE && this.props.pianoTechAppointment.view === VIEW_PIANOTECHAPPOINTMENT_LIST &&
                    <PianoTechAppointmentTable />
                }
                {this.props.user.tableName === PIANOTECHAPPOINTMENT_TABLE && this.props.pianoTechAppointment.view === VIEW_PIANOTECHAPPOINTMENT_UPDATE &&
                    <PianoTechAppointment />
                }
            </div >
        );
    }

}

export default connect(mapStateToProps)(App);
